import { lazy } from 'react';

const ExerciseBankFilters = lazy(
  () => import('../pages/Filters')
);
const ExerciseBankExercises = lazy(
  () => import('../pages/Exercises')
);

export const ExerciseBankRoutes = [
  {
    index: true,
    element: <ExerciseBankFilters />,
  },
  {
    path: 'exercicios',
    element: <ExerciseBankExercises />,
  },
  {
    path: 'exercicios/:slug',
    element: <ExerciseBankExercises />,
  },
];
